export default "__VITE_ASSET__Xciusyph__"